import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04efb28a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CoreData" }
const _hoisted_2 = { class: "employee-name-cell" }

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { useStore } from '@/store'
import { initEmptyParam } from '@/hooks/useInitParam'
import dayjs from 'dayjs'
import { ref } from 'vue'
import { getListData, getPageListData } from '@/service/main/system'
import { ElMessage, ElLoading } from 'element-plus'
import PageContent from '@/components/PageContent.vue'
import CoreDataTrend from './CoreDataTrend.vue'
import { TrendCharts } from '@element-plus/icons-vue'
import { secondToString } from '@/utils/date-format'


export default /*#__PURE__*/_defineComponent({
  __name: 'CoreData',
  setup(__props) {

initEmptyParam()
const store = useStore()
const trendDialogVisible = ref(false)
const trendEmployee = ref<any>({})

const handleTrendClick = (row: any) => {
  if (!row.empId) {
    ElMessage.warning('缺少业务员ID，无法查询趋势数据')
    return
  }
  trendEmployee.value = row
  trendDialogVisible.value = true
}

const getDeptList = async () => {
  let deptList = await getListData('/main/resourceAnalysis/getTop13DepartmentListByDeptSort', {})
  const deptOptions = deptList.map((item: any) => {
    return { title: item.name, value: item.name }
  })
  const deptItem = searchFormConfig.formItems.find((item) => item.field === 'deptName')
  deptItem!.options = deptOptions
}
getDeptList()

const queryParam = {
  timeSlot: [
    dayjs().subtract(1, 'day').startOf('date').format('YYYY-MM-DD HH:mm:ss'),
    dayjs().subtract(1, 'day').endOf('date').format('YYYY-MM-DD HH:mm:ss')
  ],
  deptName: '',
  pageNo: 1,
  pageSize: 10
}
store.commit('system/changeQueyryInfo', queryParam)

const searchCb = (formdata: any) => {
  if (formdata.timeSlot && formdata.timeSlot.length === 2) {
    const selectedDate = formdata.timeSlot[0].split(' ')[0]
    const today = dayjs().format('YYYY-MM-DD')
    if (selectedDate === today) {
      ElMessage.warning('通话相关数据次日可查')
    }
  }
}

const handleSortChange = (value: any) => {
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order === 'ascending' ? 'ascending' : 'descending'
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

// 定义筛选规则
const filterRules = [
  '筛选规则：',
  '通话1分钟以内的，不计次数，算总时长',
]

const resetCb = () => {
  return queryParam
}

// 自定义下载处理函数，避免调用 PageContent 的 exportXlsx（会触发 query 接口）
const handleDownBtnClickCustom = async () => {
  const loadingInstance = ElLoading.service({
    lock: true,
    text: '数据下载中...',
    background: 'rgba(0, 0, 0, 0.5)'
  })

  try {
    const queryInfo = store.state.system.queryInfo
    const exportParams = {
      ...queryInfo,
      ...store.state.system.orderInfo
    }

    const res = await getPageListData(
      '/main/coreData/download',
      exportParams,
      'blob'
    )

    const blob = new Blob([res], { type: 'application/octet-stream' })
    const down = document.createElement('a')
    down.download = '核心数据.xlsx'
    down.style.display = 'none'
    down.href = URL.createObjectURL(blob)
    document.body.appendChild(down)
    down.click()
    URL.revokeObjectURL(down.href)
    document.body.removeChild(down)

    ElMessage.success('下载成功')
  } catch (error) {
    console.error('下载失败', error)
    ElMessage.error('下载失败，请重试')
  } finally {
    loadingInstance.close()
  }
}

const [
  pageContentRef,
  handleResetClick,
  handleSearchClick
] = usePageSearch(resetCb, searchCb)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "coreData",
      pageUrl: "/main/coreData/query",
      downUrl: "/main/coreData/download",
      onSortChange: handleSortChange,
      onDownBtnClick: handleDownBtnClickCustom,
      downFilename: "核心数据.xlsx",
      filterRules: filterRules
    }, {
      empName: _withCtx((scope) => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString(scope.row.empName), 1),
          _createVNode(_component_el_tooltip, {
            content: "查看近两个月趋势",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                class: "trend-button",
                type: "text",
                circle: "",
                onClick: _withModifiers(($event: any) => (handleTrendClick(scope.row)), ["stop"])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(TrendCharts))
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 2
          }, 1024)
        ])
      ]),
      callDuration: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(_unref(secondToString)(Number(scope.row.callDuration))), 1)
      ]),
      _: 1
    }, 8, ["contentTableConfig"]),
    _createVNode(CoreDataTrend, {
      visible: trendDialogVisible.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((trendDialogVisible).value = $event)),
      employee: trendEmployee.value
    }, null, 8, ["visible", "employee"])
  ]))
}
}

})